// A stateless "action" dropdown — always resets to its placeholder after
// firing, so it never needs to live in Formik state. Shared by the charge
// sections (Origin/Destination/Freight) and the itinerary modal, all of
// which let the user pull data in from another flight option instead of
// re-typing it.
const CopyFromMenu = ({ sources, onCopy, label = "Copy from other option" }) => {
  if (!sources?.length) return null;

  return (
    <select
      value=""
      onChange={(e) => {
        const value = e.target.value;
        e.target.value = "";
        const source = sources.find((s) => s.key === value);
        if (source) onCopy(source);
      }}
      style={{
        appearance: "none",
        border: "1px solid #f2d896",
        background: "#fff9ec",
        color: "#b57400",
        borderRadius: 999,
        padding: "5px 12px",
        fontSize: 11.5,
        fontWeight: 600,
        cursor: "pointer",
        maxWidth: 200,
      }}
    >
      <option value="">{label}</option>
      {sources.map((s) => (
        <option key={s.key} value={s.key}>
          {s.label}
        </option>
      ))}
    </select>
  );
};

export default CopyFromMenu;
